module.exports = __webpack_public_path__ + "media/icf/acc-5f212560.png";